
import AuiToast from '../assets/js/aui-toast'
import { Dialog } from 'vant'
import store from '../store/store'
import axios from 'axios'
import user from './user/user'
import project from './project/project'
import device from './device/device'
import zxy from './device/zxy'
import chargePile from './device/charge-pile'
import dtu from './device/dtu'
import pcs from './device/pcs'
import strategy from './strategy/strategy'
import group from './group/group'
import params from './params/params'
import AuiDialog from '../assets/js/aui-dialog'
import wx from 'weixin-js-sdk'
import router from '../router/index'
// import md5 from 'md5'
// import sha256 from 'sha256'

/**
 * axios配置
 *
 */
axios.defaults.timeout = 10000
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['accept-language'] = 'zh-CN,zh;q=0.9'
// axios.defaults.headers.common['accept-language'] = 'en;q=0.9'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.request.use((reqConfig) => {
  let sensorToken = localStorage.getItem('sensorToken')
  // let timestamp = Date.now()
  let token = store.state.loginUserInfor.token
  let refreshToken = store.state.loginUserInfor.refreshToken
  if (token) {
    // ----------  萤石云摄像头，服务已弃用--------
    // reqConfig.headers['serviceCode'] = `solariot-a`
    // reqConfig.headers['timestamp'] = timestamp
    // reqConfig.headers['sign'] = md5(sha256(`solariot-a${timestamp}GBJr7xt3nEDAMlrb`))
    reqConfig.headers['server-manage-token'] = `Bearer ${sensorToken}`
    reqConfig.headers['Authorization'] = `Bearer ${token}`
    reqConfig.headers['x-refresh-token'] = `Bearer ${refreshToken}`
    reqConfig.headers['accept-language'] = `${store.state.language}`
  }
  return reqConfig
}, {})
// 拦截响应response，并做一些错误处理
axios.interceptors.response.use((response) => {
  return response.data
}, (err) => {
  AuiToast.hide()
  AuiDialog.remove()
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        Dialog({
          title: window.vm.$i18n.t('verification.tips'),
          message: err.response.data.message,
          confirmButtonText: window.vm.$i18n.t('UIComponent.sure'),
          confirmButtonColor: '#333'
        })
        // MessageBox('错误提示', err.response.data.message)
        // 用return直接返回结果，不做余下处理，否则会外层提示弹窗
        return
        // break
      case 401:
        err.message = window.vm.$i18n.t('verification.notAuthorized')
        AuiDialog.alert({
          title: window.vm.$i18n.t('verification.tips'),
          msg: window.vm.$i18n.t('verification.notAuthorized'),
          buttons: [window.vm.$i18n.t('UIComponent.sure')]
        }, function (ret) {
          if (ret.buttonIndex === 1) {
            store.state.loginUserInfor = {}
            localStorage.removeItem('loginUserInfor')
            if (window.__wxjs_environment === 'miniprogram') {
              wx.miniProgram.reLaunch({url: `/pages/login/login`})
              return
            }
            router.replace({path: '/login'})
            setTimeout(function () {
              location.reload()
            }, 1000)
          }
        })
        return
      case 403:
        err.message = window.vm.$i18n.t('verification.noPermission')
        break
      case 404:
        err.message = window.vm.$i18n.t('verification.requestAddressError')
        break
      case 409:
        err.message = window.vm.$i18n.t('verification.alreadyExist')
        break
      case 422:
        break
      case 500:
        err.message = window.vm.$i18n.t('verification.serverInternalError')
        break
      case 502:
        err.message = window.vm.$i18n.t('verification.gatewayError')
        break
      case 504:
        err.message = window.vm.$i18n.t('verification.requestTimeout')
        break
      default:
    }
    Dialog({
      title: window.vm.$i18n.t('verification.tips'),
      message: err.response.data.message,
      confirmButtonText: window.vm.$i18n.t('UIComponent.sure'),
      confirmButtonColor: '#333'
    })
  } else {
    Dialog({
      title: window.vm.$i18n.t('verification.tips'),
      message: err.message,
      confirmButtonText: window.vm.$i18n.t('UIComponent.sure'),
      confirmButtonColor: '#333'
    })
  }
  // AuiDialog.alert({
  //   title: window.vm.$i18n.t('verification.tips'),
  //   msg: err.response.data.message,
  //   buttons: [window.vm.$i18n.t('UIComponent.sure')]
  // }, function (ret) {
  //   console.log(ret)
  // })
  return Promise.reject(err)
})
const http = {
  user,
  project,
  device,
  strategy,
  group,
  params,
  zxy,
  dtu,
  pcs,
  chargePile
}
export default http
